<template>
  <div class="row justify-content-center">
    <div class="col-md-10">
      <div class="comment mt-4">
        <div class="d-flex align-items-start mb-3">
          <img :src="userPic" class="mr-3 rounded-circle" width="48" height="48" alt="">
          <div class="input-group flex-nowrap">
            <!-- @keyup="autogrow($event)" -->
            <textarea rows="1"
              v-model="newComment"
              type="text"
              class="form-control bg-light py-2"
              placeholder="新增留言..."
              aria-label="Username"
              aria-describedby="addon-wrapping"
              @focus="autogrow($event)"
              @keydown="autogrow($event)"
            />
            <div class="input-group-prepend">
              <button
                class="input-group-text btn bg-light rounded-right"
                id="addon-wrapping"
                @click="submitForm(null, newComment)"
              >
                <div class="spinner-grow spinner-grow-sm" role="status" v-if="isLoading.send">
                  <span class="sr-only">Loading...</span>
                </div>
                <i class="material-icons" v-else>send</i>
              </button>
            </div>
          </div>
        </div>
        <div v-if="!loading">
          <div class="mb-3" v-for="(item) in tempComments" :key="item.id">
            <div class="media" >
              <div class="media-body">
                <div class="media-inner p-3">
                  <comment-template :post-name="postName" :admin-auth="adminAuth"
                    :loading="isLoading.send" :item="item" :type="1"
                    :user-id="userId" @openDeleteModal="openDelete"
                    @update="updateData"></comment-template>
                </div>
                <!-- 第二層 -->
                <div class="mt-2" v-for="(reply) in item.reply" :key="reply.id">
                  <div class="row justify-content-end">
                    <div class="col-md-10 col-11">
                      <div class="media-body">
                        <div class="media-inner p-3">
                          <comment-template :post-name="postName"
                            admin-auth="adminAuth"
                            :loading="isLoading.send"
                            :item="reply" :type="2"
                            :user-id="userId"
                            @openDeleteModal="openDelete" @update="updateData">
                          </comment-template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-end" v-if="item.reply.length > 0">
                  <div class="col-md-10 col-11">
                    <div class="input-group flex-nowrap mt-1">
                    <!-- @keyup="autogrow($event)" -->
                      <textarea rows="1"
                        v-model="item.replyMsg"
                        type="text"
                        class="form-control bg-light py-2"
                        placeholder="新增留言..."
                        aria-label="Username"
                        aria-describedby="addon-wrapping"
                        @focus="autogrow($event)"
                        @keydown="autogrow($event)"
                      />
                      <div class="input-group-prepend">
                        <button
                          class="input-group-text btn bg-light rounded-right"
                          id="addon-wrapping"
                          @click="submitForm(item.id, item.replyMsg)"
                        >
                          <div class="spinner-grow spinner-grow-sm" role="status"
                            v-if="isLoading.send">
                            <span class="sr-only">Loading...</span>
                          </div>
                          <i class="material-icons" v-else>send</i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.reply.length == 0" class="input-group flex-nowrap mt-1">
                <!-- @keyup="autogrow($event)" -->
              <textarea rows="1"
                v-model="item.replyMsg"
                type="text"
                class="form-control bg-light py-2"
                placeholder="新增留言..."
                aria-label="Username"
                aria-describedby="addon-wrapping"
              />
              <div class="input-group-prepend">
                <button
                  class="input-group-text btn bg-light rounded-right"
                  id="addon-wrapping"
                  @click="submitForm(item.id, item.replyMsg)"
                >
                  <div class="spinner-grow spinner-grow-sm" role="status" v-if="isLoading.send">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <i class="material-icons" v-else>send</i>
                </button>
              </div>
            </div>
          </div>
          <infinite-loading @infinite="infiniteHandler">
            <small slot="no-more" class="text-muted"></small>
            <small slot="no-results" class="text-muted"></small>
          </infinite-loading>
        </div>
      </div>
      <delete-modal @deleteSure="deleteComment()" message="確定要刪除這則留言？"></delete-modal>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'comment',
  props: {
    entity: String,
    scope: String,
    userId: String,
    userPic: String,
    adminAuth: String, // 確認是否有 Admin 權限（可刪除所有人的留言）
    loading: Boolean, // 課程內容是否還在 loading
    postName: String, // 單元名稱
  },
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      newComment: '',
      comments: [],
      tempComments: [],
      cacheData: [],
      page: {
        current_page: 0,
      },
      likes: [],
      isLoading: {
        send: false,
        getComment: false,
      },
      deleteID: '',
      deleteType: -1,
    };
  },
  methods: {
    infiniteHandler($state) {
      const vm = this;
      if (!vm.isLoading.getComment && this.page.current_page > 0) {
        vm.isLoading.getComment = true;
        axios.get(`/api/comments?scope=${this.scope}&entity=${this.entity}&paged=10`, {
          params: {
            page: this.page.current_page + 1,
          },
        }).then(({ data }) => {
          vm.isLoading.getComment = false;
          if (data.data.length > 0) {
            this.gaTrackEvent('Comment', 'More', this.postName);
            this.page = data.meta.pagination;
            data.data.forEach((item) => {
              this.$set(item, 'replyMsg', '');
              this.$set(item, 'isReply', false);
              this.$set(item, 'isLike', vm.checkLikeOrNot(item.options));
              item.reply.forEach((second) => {
                this.$set(second, 'isLike', vm.checkLikeOrNot(second.options));
                this.$set(second, 'replyMsg', '');
              });
              item.reply.sort((a, b) => a.created_at.timestamp - b.created_at.timestamp);
              if (!this.tempComments.some((tempComment) => tempComment.id == item.id)) {
                this.tempComments.push(item);
              }
            });
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      } else {
        $state.complete();
      }
    },
    getData(page = 1) {
      const vm = this;
      vm.tempComments = [];
      axios.get(`/api/comments?scope=${this.scope}&entity=${this.entity}&paged=10`).then((res) => {
        res.data.data.forEach((comment) => {
          this.$set(comment, 'replyMsg', '');
          this.$set(comment, 'isReply', false);
          this.$set(comment, 'isLike', vm.checkLikeOrNot(comment.options));
          comment.reply.forEach((second) => {
            this.$set(second, 'isLike', vm.checkLikeOrNot(second.options));
            this.$set(second, 'replyMsg', '');
          });
          comment.reply.sort((a, b) => a.created_at.timestamp - b.created_at.timestamp);
          vm.tempComments.push(comment);
        });
        this.page = res.data.meta.pagination;
        // this.cacheData = [];
        // this.comments.forEach((item) => {

        //   this.cacheData.push(item);
        // });

        // this.tempComments = JSON.parse(JSON.stringify(this.cacheData));
      })
        .catch((err) => {
          console.log(err);
        });
    },
    openDelete(id, type) {
      this.deleteID = id;
      this.deleteType = type;
      $('#deleteModal').modal('show');
    },
    deleteComment() {
      axios.delete(`/api/comment/${this.deleteID}`).then((res) => {
        if (res.status == 200) {
          if (this.deleteType == 1) {
            const index = this.tempComments.findIndex((comment) => comment.id == this.deleteID);
            this.tempComments.splice(index, 1);
          } else if (this.deleteType == 2) {
            let parentID = -1;
            let childID = -1;
            this.tempComments.forEach((comment, index) => {
              comment.reply.forEach((child, childIndex) => {
                if (child.id == this.deleteID) {
                  parentID = index;
                  childID = childIndex;
                }
              });
            });
            if (parentID !== -1 && childID !== -1) {
              this.tempComments[parentID].reply.splice(childID, 1);
            }
          }
          this.deleteID = '';
          this.deleteType = -1;
        }
      });
    },
    updateData(id, type, data) {
      const vm = this;
      if (type == 1) {
        const index = this.tempComments.findIndex((comment) => comment.id == id);
        vm.$set(data, 'replyMsg', '');
        vm.$set(data, 'isLike', vm.checkLikeOrNot(data.options));
        data.reply.forEach((second) => {
          this.$set(second, 'isLike', vm.checkLikeOrNot(second.options));
          this.$set(second, 'replyMsg', '');
        });
        vm.$set(this.tempComments, index, data);
      } else if (type == 2) {
        let parentID = -1;
        let childID = -1;
        this.tempComments.forEach((comment, index) => {
          comment.reply.forEach((child, childIndex) => {
            if (child.id == id) {
              parentID = index;
              childID = childIndex;
            }
          });
        });
        if (parentID !== -1 && childID !== -1) {
          vm.$set(data, 'replyMsg', '');
          vm.$set(data, 'isLike', vm.checkLikeOrNot(data.options));
          vm.$set(this.tempComments[parentID].reply, childID, data);
        }
      }
    },
    autogrow(e) {
      setTimeout(() => {
        e.target.style.cssText = 'height:auto; padding:0';
        e.target.style.cssText = `height:${e.target.scrollHeight}px`;
      }, 0);
    },
    submitForm(id, replyMsgData = '') {
      if (replyMsgData !== '') {
        this.isLoading.send = true;
        const data = {
          scope: this.scope,
          entity: 'Posts',
          content: replyMsgData.replace(/\n/g, '<br>'),
          reply: id || null,
        };
        axios.post('/api/comment', data).then((res) => {
          this.cacheData = [];
          if (id) {
            const index = this.tempComments.findIndex((comment) => comment.id == id);
            this.tempComments[index].reply.push(res.data.data);
            this.tempComments[index].replyMsg = '';
            this.gaTrackEvent('Comment', 'Reply', this.postName);
          } else {
            this.tempComments.unshift(res.data.data);
            this.gaTrackEvent('Comment', 'Leave Comment', this.postName);
          }
          this.newComment = '';
          this.isLoading.send = false;
        })
          .catch((err) => {
            console.log(err);
            this.isLoading.send = false;
          });
      }
    },
    checkLikeOrNot(options) {
      if (options && options.hasOwnProperty('likes')) {
        const likesUser = options.likes;
        if (likesUser.some((user) => user == this.userId)) {
          return true;
        }
        return false;
      }
      return false;
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.media-inner {
  border: 2px solid #e8eaf6;
  border-radius: 4px;
}
.border-radius-bottom-0 {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.border-radius-bottom-0 {
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
}
</style>
